import * as types from '../mutation-types'
import localStorage from 'store'

const state = {
  onboardingType: null,
  color: null,
  disableScreen: false,
  onboardingStarted: false,
  skippedOrCompleted: []
}

const getters = {
  onboardingType: (state) => {
    return state.onboardingType
  },
  onboardingColor: (state) => {
    return state.color
  },
  onboardingDisableScreen: (state) => {
    return state.disableScreen
  },
  onboardingStarted: (state) => {
    return state.onboardingStarted
  },
  onboardingPreviouslyCompleted: (state) => (onboardingType) => {
    return onboardingType && state.skippedOrCompleted.includes(onboardingType)
  }
}

// actions
const actions = {
  setOnboardingType ({ commit }, { type }) {
    commit(types.SET_ONBOARDING_TYPE, type)
  },
  setOnboardingColor ({ commit }, { color }) {
    commit(types.SET_ONBOARDING_COLOR, color)
  },
  initJudgingRegistrationOnboarding ({ commit }) {
    commit(types.INIT_ONBOARDING_COMPLETED)
    commit(types.INIT_ONBOARDING, { type: 'judgeregistration', color: '#00ADEE' })
  },
  initMakeDesktopOnboarding ({ commit }) {
    commit(types.INIT_ONBOARDING_COMPLETED)
    commit(types.INIT_ONBOARDING, { type: 'makehomedesktop', color: '#00ADEE' })
  },
  initMakeMobileOnboarding ({ commit }) {
    commit(types.INIT_ONBOARDING_COMPLETED)
    commit(types.INIT_ONBOARDING, { type: 'makehomemobile', color: '#00ADEE' })
  },
  setDisableScreen ({ commit }, value) {
    commit(types.SET_DISABLE_SCREEN, value)
  },
  startOnboarding ({ commit }) {
    commit(types.SET_ONBOARDING_STARTED, true)
  },
  completeOnboarding ({ commit }) {
    commit(types.SET_ONBOARDING_STARTED, false)
    commit(types.SET_ONBOARDING_COMPLETED)
  }
}

const mutations = {
  [types.SET_ONBOARDING_TYPE] (state, type) {
    state.onboardingType = type
  },
  [types.SET_ONBOARDING_COLOR] (state, color) {
    state.color = color
  },
  [types.INIT_ONBOARDING] (state, { type, color }) {
    state.color = color
    state.onboardingType = type
  },
  [types.SET_DISABLE_SCREEN] (state, value) {
    state.disableScreen = value
  },
  [types.SET_ONBOARDING_STARTED] (state, value) {
    state.onboardingStarted = value
  },
  [types.SET_ONBOARDING_COMPLETED] (state) {
    if (!state.skippedOrCompleted.includes(state.onboardingType)) {
      state.skippedOrCompleted.push(state.onboardingType)
      localStorage.set('onboardingSkippedOrCompleted', JSON.stringify(state.skippedOrCompleted))
    }
  },
  [types.INIT_ONBOARDING_COMPLETED] (state) {
    const completedOnboardings = JSON.parse(localStorage.get('onboardingSkippedOrCompleted') || '[]')
    if (completedOnboardings) {
      state.skippedOrCompleted = completedOnboardings
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
